import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "/Users/robingenz/Documents/GitHub/capacitor-community/sqlite/electron/build/electron/src/index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(srcExports);